import { useTableContext } from 'lib/context/TableContext/TableContext';

import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';

const EmptyBillingProviders = () => {
  const { setShowModal } = useTableContext();
  return (
    <>
      <div className="flex w-full flex-col items-center pb-20">
        <Icon icon="illustration-empty-table" />
        <h1 className="text-base font-500 text-primary-900">No billing providers found!</h1>
        <Button
          className="mt-4"
          textClassName="whitespace-nowrap"
          text="Add billing provider"
          icon="add-square-mono"
          size="xs"
          variant="link"
          onClick={() => {
            setShowModal(true);
          }}
        />
      </div>
    </>
  );
};
export default EmptyBillingProviders;
